// React
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import 'cleave.js/dist/addons/cleave-phone.in';
import React, { useEffect, useState } from 'react';

// Hooks
import { useLoading } from '../../../hook/useLoading';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { CreateUsers, UpdateUsers, Users } from '../../../store/actions';

// Helpers
import * as url from '../../../helpers/url_helper';
import { APIClient } from '../../../helpers/api_helper';

// Components
import { FormOfficeSelect } from './FormOfficeSelect';
import { LoadingScreen } from '../../../components/loading_screen';
import { SelectSellers } from '../components/SelectSellers';
import user_pick from '../../../assets/images/users/user-pic.jpg';

import classnames from 'classnames';
import { PageWrapper } from '../../../components/pageWrapper';

const FormUsers = () => {
  const [user, setUser] = useState();
  const [profiles, setProfiles] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSeller, setIsSeller] = useState(false);

  const { users } = useSelector((state) => ({
    users: state.Users.users,
  }));

  const dispatch = useDispatch();
  const history = useHistory();
  const api = new APIClient();
  const { loadingWithTime } = useLoading();

  Yup.addMethod(Yup.object, 'seller', function (errorMessage) {
    return this.test('seller', errorMessage, function (value) {
      const { path, createError } = this;

      if (!isSeller) {
        return true;
      } else {
        if (value?.value !== null) {
          return true;
        } else {
          createError({ path, message: errorMessage });
        }
      }
    });
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: user ? user.name : '',
      usernameInput: user ? user.username : '',
      emailInput: user ? user.email : '',
      passwordInput: '',
      profileInput: user
        ? {
            value: user.profile_id,
            label: user.profile_name,
          }
        : null,
      sellerInput: user
        ? {
            value: user.seller_id,
            label: user.seller,
          }
        : null,
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      usernameInput: Yup.string().required('Usuário é obrigatório'),
      emailInput: Yup.string().required('Digite um email válido'),
      passwordInput: user
        ? Yup.string()
        : Yup.string().required('Digite uma senha'),
      profileInput: Yup.object().required('Selecione um perfil ').nullable(),
      sellerInput: Yup.object().seller('Selecione um vendedor').nullable(),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        username: values.usernameInput || null,
        email: values.emailInput || null,
        auth_2fa: false,
        force_change_passw: false,
        profile_id: values.profileInput.value || null,
        photo: image || null,
        active: true,
        password: values.passwordInput || null,
        seller_id: values?.sellerInput?.value || null,
      };

      loadingWithTime(1000);
      if (user) {
        dispatch(UpdateUsers({ id: user.id, data: valuesToSubmit }));
      } else {
        dispatch(CreateUsers(valuesToSubmit));
        history.push('/configuracoes/usuarios');
      }
    },
  });

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const findUser = (id) => {
    const user = (users || []).find((usr) => usr.id === id);

    if (user) {
      setUser(user);
      setIsUpdate(true);
    }
    setLoading(false);
  };

  /**
   * function to create custom data for select input
   * based on data passing as props
   */
  const createData = (data) => {
    return data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
  };

  /**
   * function to get select of payment-methods
   */
  const loadOptions = async () => {
    const response = await api.get(url.BASE + '/register/profiles');
    const result = await response;
    setProfiles(result);
  };

  const [activeTab, setActiveTab] = useState('1');

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    dispatch(Users());
    loadOptions();
  }, [dispatch]);

  useEffect(() => {
    const full_url = document.URL; // Get current url
    const url_array = full_url.split('/'); // Split the string into an array with / as separator
    const last_segment = url_array[url_array.length - 1];
    findUser(last_segment);
  }, [users]);

  return (
    <LoadingScreen
      loading={loading}
      titleMetaTag={isUpdate ? 'Editar Usuário' : 'Novo Usuário'}
    >
      <PageWrapper title={isUpdate ? 'Editar Usuário' : 'Novo Usuário'}>
        <Row>
          {isUpdate && user && (
            <Col xxl={3}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                      {}
                      <img
                        src={
                          image ? image : user.photo ? user.photo : user_pick
                        }
                        className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                        alt="user-profile"
                      />
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                        <Input
                          id="profile-img-file-input"
                          type="file"
                          className="profile-img-file-input"
                          onChange={(e) => {
                            if (
                              e.target.files[0].type === 'image/jpeg' ||
                              e.target.files[0].type === 'image/png'
                            ) {
                              getBase64(e.target.files[0]).then((data) => {
                                setImage(data);
                              });
                            } else {
                              alert('Formato inválido');
                            }
                          }}
                        />
                        <Label
                          htmlFor="profile-img-file-input"
                          className="profile-photo-edit avatar-xs"
                        >
                          <span className="avatar-title rounded-circle bg-light text-body">
                            <i className="ri-camera-fill"></i>
                          </span>
                        </Label>
                      </div>
                    </div>
                    <h5 className="fs-16 mb-1">{user.name || ''}</h5>
                    <p className="text-muted mb-0">{user.email || ''}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}

          <Col
            xxl={isUpdate ? 9 : 12}
            xl={isUpdate ? 9 : 12}
            md={isUpdate ? 9 : 12}
          >
            <Card>
              <CardHeader>
                <Nav
                  className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        tabChange('1');
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="fas fa-home"></i>
                      Dados Cadastrais
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to="#"
                      className={classnames({ active: activeTab === '2' })}
                      disabled={!isUpdate}
                      onClick={() => {
                        tabChange('2');
                      }}
                      type="button"
                    >
                      <i className="far fa-user"></i>
                      Escritórios
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Form
                    autoComplete="off"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <CardBody className="p-4">
                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="name" className="form-label">
                              Nome
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="nameInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.nameInput || ''}
                            />
                            {validation.touched.nameInput &&
                            validation.errors.nameInput ? (
                              <p className="labelErrorValidation">
                                {validation.errors.nameInput}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md={6} sm={12}>
                          <div className="mb-3">
                            <Label htmlFor="emailInput" className="form-label">
                              Email
                            </Label>
                            <Input
                              type="email"
                              className="form-control"
                              id="emailInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.emailInput || ''}
                            />
                            {validation.touched.emailInput &&
                            validation.errors.emailInput ? (
                              <p className="labelErrorValidation">
                                {validation.errors.emailInput}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md={4} sm={12}>
                          <Label htmlFor="profileInput" className="form-label">
                            Perfil
                          </Label>
                          <Select
                            value={
                              validation.values.profileInput || {
                                value: null,
                                label: 'Selecione um perfil',
                              }
                            }
                            onChange={(e) => {
                              const event = {
                                target: {
                                  name: 'profileInput',
                                  value: e,
                                },
                              };
                              validation.handleChange(event);

                              const { label } = event.target.value;
                              if (label === 'Corretor') {
                                setIsSeller(true);
                              } else {
                                setIsSeller(false);
                              }
                            }}
                            onBlur={validation.handleBlur}
                            options={createData(profiles) || []}
                            inputId="profileInput"
                          />
                          {validation.touched.profileInput &&
                          validation.errors.profileInput ? (
                            <p className="labelErrorValidation">
                              {validation.errors.profileInput}
                            </p>
                          ) : null}
                        </Col>

                        <Col md={4}>
                          <div className="mb-3">
                            <Label htmlFor="name" className="form-label">
                              Usuário
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="usernameInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.usernameInput || ''}
                            />
                            {validation.touched.usernameInput &&
                            validation.errors.usernameInput ? (
                              <p className="labelErrorValidation">
                                {validation.errors.usernameInput}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md={4} sm={12}>
                          <div className="mb-3">
                            <Label
                              htmlFor="passwordInput"
                              className="form-label"
                            >
                              Senha
                            </Label>
                            <Input
                              type="password"
                              className="form-control"
                              id="passwordInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.passwordInput || ''}
                            />
                            {validation.touched.passwordInput &&
                            validation.errors.passwordInput ? (
                              <p className="labelErrorValidation">
                                {validation.errors.passwordInput}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        {isSeller && (
                          <Col md={4}>
                            <div className="mb-3">
                              <Label
                                htmlFor="sellerInput"
                                className="form-label"
                              >
                                Vendedor
                              </Label>
                              <SelectSellers validation={validation} />
                              {validation.touched.sellerInput &&
                              validation.errors.sellerInput ? (
                                <p className="labelErrorValidation">
                                  {validation.errors.sellerInput}
                                </p>
                              ) : null}
                            </div>
                          </Col>
                        )}
                      </Row>
                    </CardBody>

                    <CardFooter>
                      <Col md={12}>
                        <div className="text-end d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-link me-3"
                            onClick={() => {
                              history.goBack();
                            }}
                          >
                            Cancelar
                          </button>
                          <button type="submit" className="btn btn-primary">
                            Salvar
                          </button>
                        </div>
                      </Col>
                    </CardFooter>
                  </Form>
                </TabPane>

                <TabPane tabId="2">
                  <FormOfficeSelect userId={user ? user.id : null} />
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </Row>
      </PageWrapper>
    </LoadingScreen>
  );
};

export default FormUsers;
